export default __webpack_public_path__ + "windows0b19c7.png";